import React from "react"
import { InfoWrapper } from "../../Order/ManageOrder/DeliverOrder/FailedDeliveries.styled"

type Props = {
  showManual?: boolean
}

const ActionInfoBox = ({ showManual = true }: Props) => {
  return (
    <InfoWrapper>
      <b>Auto</b>{" "}
      <p>Brink commerce will perform the necessary requests to fulfill the action.</p>
      {showManual && (
        <>
          <b>Manual</b>{" "}
          <p>
            The action has been performed in an external system and will be stored as manually
            completed.
          </p>
        </>
      )}
      <b>Skip</b> <p>The action will be skipped entirely.</p>
    </InfoWrapper>
  )
}

export default ActionInfoBox
